<template>
  <Badge :variant="CUSTOMER_TIER_VARIANT[customerTier]" :size="size">
    {{ customerTier }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { CustomerTier } from '@carvia/ros-client-types';

defineProps<{
  customerTier: CustomerTier;
  size?: 'sm' | 'md';
}>();

const CUSTOMER_TIER_VARIANT: Record<CustomerTier, BadgeVariant> = {
  [CustomerTier.NORMAL]: 'info',
  [CustomerTier.SILVER]: 'obsidian',
  [CustomerTier.GOLD]: 'warning',
  [CustomerTier.PLATINUM]: 'dark',
};
</script>
